/**
 * The type of User Sign In
 */
export enum UserSignInType {
  /**
   * A card containing encoded data that is read by placing
   * the card over Sioslife devices, used to provide access
   * to our Systems.
   */
  Card = 'card',

  /**
   * Allows any authorized user to quickly sign in a already
   * authenticated device.
   */
  Quick = 'quick',

  /**
   * Allows any professional user to sign in with a code
   */
  Code = 'code',
}
